import React from 'react';
import { Icon, Label, List } from 'semantic-ui-react';
import {
  DocusignTimelineProgress,
  getDocusignStageLabel,
  isDocusignPriorityWaitPhase,
} from '../../utils/docusignProgressTimelineUtils';

type Props = {
  phases: DocusignTimelineProgress[];
};

const statusIcon = (status: DocusignTimelineProgress['status'], stage: string) => {
  if (status === 'success' || stage === 'concluido') {
    return { name: 'check circle' as const, color: 'green' as const };
  }
  if (status === 'error' || stage === 'erro' || stage === 'cancelado') {
    return { name: 'times circle' as const, color: 'red' as const };
  }
  return null;
};

const formatTime = (timestamp?: string) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
};

export const DocusignPhaseTimeline: React.FC<Props> = ({ phases }) => {
  if (!phases.length) {
    return null;
  }

  return (
    <List divided relaxed style={{ marginTop: '12px', maxHeight: '220px', overflowY: 'auto' }}>
      {phases.map((phase, index) => {
        const icon = statusIcon(phase.status, phase.stage);
        const time = formatTime(phase.timestamp);
        return (
          <List.Item key={`${phase.stage}-${phase.timestamp ?? index}-${phase.message}`}>
            {icon && (
              <Icon name={icon.name} color={icon.color} style={{ marginTop: '2px' }} />
            )}
            <List.Content style={icon ? undefined : { marginLeft: 0 }}>
              <List.Header style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                <span>{getDocusignStageLabel(phase.stage)}</span>
                {isDocusignPriorityWaitPhase(phase) && (
                  <Label size="tiny" color="orange">
                    Prioridade
                  </Label>
                )}
                {phase.progress > 0 && phase.status === 'processing' && (
                  <Label size="tiny" basic>
                    {phase.progress}%
                  </Label>
                )}
                {time && (
                  <span style={{ fontSize: '0.85em', color: '#888', fontWeight: 'normal' }}>{time}</span>
                )}
              </List.Header>
              <List.Description style={{ marginTop: '4px', color: '#555' }}>
                {phase.message}
              </List.Description>
            </List.Content>
          </List.Item>
        );
      })}
    </List>
  );
};

export default DocusignPhaseTimeline;
